import { useMemo } from 'react'
import { useAuthStore } from '../store/authStore'
import useManagerStore from '../store/managerStore'
import { getReadyBranchTenantId } from '../lib/tenantId'

// The tenant whose notifications may be shown: the active branch, once
// branch bootstrap has finished and confirmed the user really has it. Null
// until then, so nothing is fetched or displayed for a stale tenant id.
export function useNotificationTenantId() {
  const tenantId = useManagerStore((s) => s.tenantId)
  const branches = useAuthStore((s) => s.branches)
  const branchBootstrapStatus = useAuthStore((s) => s.branchBootstrapStatus)
  return useMemo(
    () => getReadyBranchTenantId(tenantId, branches, branchBootstrapStatus),
    [tenantId, branches, branchBootstrapStatus]
  )
}
